import { expectedKanoStatementKeys } from 'app/models/questions/property-validator/MatrixPropertyValidator'

export class KanoStatementKeyValidationError extends Error {
  constructor(receivedStatementKeys: string[], questionKey: string) {
    super()
    this.name = 'Invalid Kano statement labels received from server'
    this.message = `The Kano with key ${questionKey} has at least one invalid or missing statement key. The expected statement keys are <${expectedKanoStatementKeys.join(', ')}>. But it has <${receivedStatementKeys.join(', ')}>`
  }
}
